import script from "./YoutubeFilmlibrary.vue?vue&type=script&setup=true&lang=js"
export * from "./YoutubeFilmlibrary.vue?vue&type=script&setup=true&lang=js"

import "./YoutubeFilmlibrary.vue?vue&type=style&index=0&id=d33052e8&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d33052e8"]])

export default __exports__